import { createAsyncThunk } from "@reduxjs/toolkit";
import { Advertise } from "../../../client/services";
import { toastHandler } from "../../../utils/toastHandler";
import { FindAdvertise } from "../../advertise/api/interface";

export const findAdvertiseExport = createAsyncThunk(
  "advertiseExport/findAdvertiseExport",
  async (values: FindAdvertise, { rejectWithValue }) => {
    try {
      const response = await Advertise.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);